module.exports = __webpack_public_path__ + "static/media/control-distancia-gris.485742a9.png";